<template>
  <div class="padded">
    <h2 class="no-top">Intensity Calculator</h2>
    <intensity-calculator-container/>
  </div>
</template>

<script>
import IntensityCalculatorContainer from "../components/intensity/IntensityCalculatorContainer.vue";

export default {
  components: {
    IntensityCalculatorContainer
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/IntensityCalculator.vue